/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { SubNav } from '../ui';
import MemberDetails from '../detail/components/memberDetails';
import MemberOrders from '../detail/components/memberOrders';
import OrderRight from '../detail/components/orderRight';
import HotCoachChart from '../../hotCoachMap';
import styles from '../detail/index.less';

/**
 * 会员信息（一级 tab）
 * ------------------------------------------------------------------
 * 二级：会员明细 / 会员订单 / 订单权益 / 用户分布。
 * 四个列表组件本轮零改动，只换外层容器；框架要求的列字段（家庭卡人数、
 * 累计支付金额、主卡所属商家、换绑比例…）在各自组件内已实现。
 *
 * 二级导航改用 SubNav（平级、无第三层 → 一行文字 tab），与经营看板、
 * 商家档案统一；此前是 arco 圆角 pill。
 *
 * 「会员训练情况」框架文档标注本期没有，故未开 tab。
 */
const GROUPS = [
  { value: 'detail', label: '会员明细' },
  { value: 'order', label: '会员订单' },
  { value: 'right', label: '订单权益' },
  { value: 'distribution', label: '用户分布' },
];

const UserTab = (props) => {
  const { tenantId, tenantInfo = {} } = props;
  const [group, setGroup] = useState('detail');

  return (
    <div>
      <SubNav groups={GROUPS} groupValue={group} onGroupChange={setGroup} />

      <div className={styles.tabBody}>
        {group === 'detail' && <MemberDetails tenantId={tenantId} />}
        {group === 'order' && <MemberOrders tenantId={tenantId} />}
        {group === 'right' && <OrderRight tenantId={tenantId} />}
        {group === 'distribution' && (
          <HotCoachChart
            tenantId={tenantId}
            coachUserId={tenantInfo.coachUserId}
          />
        )}
      </div>
    </div>
  );
};

export default UserTab;
